import { safeNumber } from './dataQuality.helpers';
export function makeTableRows(series = []) {
  return (series || []).map((r) => {
    const raw = r.__raw || {
      Missing_Type7: Number(r.Missing_Type7) || 0,
      Actual:        Number(r.Actual) || 0,
      Missing_Type9: Number(r.Missing_Type9) || 0,
      Uncertain:     Number(r.Uncertain) || 0,
      PendingMissing:Number(r.PendingMissing) || 0,
    };
    const t7 = safeNumber(raw.Missing_Type7);
    const act = safeNumber(raw.Actual);
    const t9 = safeNumber(raw.Missing_Type9);
    const unc = safeNumber(raw.Uncertain);
    const pend = safeNumber(raw.PendingMissing);
    const expected = safeNumber(raw.ExpectedTotal ?? r.ExpectedTotal ?? 0);
    const display = r.__display || {};
    const pctT7 = Number.isFinite(display?.Missing_Type7) ? display.Missing_Type7 : 0;
    const pctAct = Number.isFinite(display?.Actual) ? display.Actual : 0;
    const pctT9 = Number.isFinite(display?.Missing_Type9) ? display.Missing_Type9 : 0;
    const pctUnc = Number.isFinite(display?.Uncertain) ? display.Uncertain : 0;
    const pctPend = Number.isFinite(display?.PendingMissing) ? display.PendingMissing : 0;
    const readingIso = r.iso || (r.fullDate ? (() => {
      try {
        const dt = new Date(r.fullDate);
        if (!isNaN(dt.getTime())) return dt.toISOString().slice(0,10);
        return null;
      } catch (e) { return null; }
    })() : (r.day ? (() => {
      try {
        const dt = new Date(r.day);
        if (!isNaN(dt.getTime())) return dt.toISOString().slice(0,10);
        return null;
      } catch (e) { return null; }
    })() : (r.__raw && r.__raw.ReadingDate ? (() => {
      try {
        const dt = new Date(r.__raw.ReadingDate);
        if (!isNaN(dt.getTime())) return dt.toISOString().slice(0,10);
        return null;
      } catch (e) { return null; }
    })() : null)));
    return {
      ReadingDate: readingIso || null,
      Missing_Type7: t7,
      Actual: act,
      Missing_Type9: t9,
      Uncertain: unc,
      PendingMissing: pend,
      ExpectedTotal: expected,
      Percent_Missing_Type7: pctT7,
      Percent_Actual:        pctAct,
      Percent_Missing_Type9: pctT9,
      Percent_Uncertain:     pctUnc,
      Percent_PendingMissing: pctPend,
    };
  });
}
